module.exports = __webpack_public_path__ + "components/app-buttons/static/app-store-198e9bc3ad72825423c2820291515e4f.svg";